export default __webpack_public_path__ + "static/media/screen1.ddc2a0cd.png";